export function newestFirst(images) {
  return [...images].sort((left, right) => (right.seoId || 0) - (left.seoId || 0));
}

export function prioritizeFeaturedImages(images, featuredSeoIds = []) {
  const orderedImages = newestFirst(images);

  if (!featuredSeoIds.length) {
    return orderedImages;
  }

  const priority = new Map(
    featuredSeoIds.map((seoId, index) => [seoId, index])
  );

  return orderedImages.sort((left, right) => {
    const leftPriority = priority.has(left.seoId)
      ? priority.get(left.seoId)
      : Number.MAX_SAFE_INTEGER;
    const rightPriority = priority.has(right.seoId)
      ? priority.get(right.seoId)
      : Number.MAX_SAFE_INTEGER;

    return leftPriority - rightPriority;
  });
}
